import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  ConfigService,
  DeepPartial,
  EntityService
} from 'viggo-sistemas-core-web';

import { IParcelasPagar } from '@app/modules/contas-pagar/models/parcelas.model';
import { Observable } from 'rxjs';
import { PaginationOptions } from 'viggo-sistemas-core-web/modules/core/model/entity-params';
import { IFornecedor } from '../models/fornecedor.model';

@Injectable()
export class FornecedorService extends EntityService<IFornecedor> {
  constructor(protected configService: ConfigService) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'fornecedor',
        pluralBaseEntityEndPoint: 'fornecedores'
      }
    );
  }

  /**
   * Pega todas as parcelas em aberto de um cliente
   * @param fornecedor_id
   * @param include
   * @param pagination
   * @param where
   * @param order_by
   * @returns
   */
  public pegarParcelasAbertas(
    fornecedor_id: string,
    include?: string[],
    pagination?: {
      require_pagination?: boolean;
      page_size?: number;
      page?: number;
    },
    where?: DeepPartial<IParcelasPagar>,
    order_by?: string
  ): Observable<any> {
    const url = `${this.baseURL}/${fornecedor_id}/conta_pagar_parcelas`;
    let params = new HttpParams();

    if (include) {
      params = params.append('include', include.join(','));
    }
    if (pagination) {
      params = params
        .append('require_pagination', pagination.require_pagination)
        .append('page_size', pagination.page_size)
        .append('page', pagination.page);
    }

    if (where) {
      params = params.append(`${Object.keys(where)[0]}`, where.status);
    }

    if (order_by) {
      params = params.append('order_by', order_by);
    }

    return this.http.get<{
      fornecedor: { conta_pagar_parcelas: IParcelasPagar[] };
      pagination: PaginationOptions;
    }>(url, { headers: this.getHeader(), params });
  }
}
